import { useState } from 'react';
import { getErrorMessage } from '../../lib/api';

export default function ResetPasswordScreen({ username, onSubmit, onBack, loading }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const isPasswordMatch = newPassword === confirmPassword && newPassword.length >= 6;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccessMsg('');

    if (!newPassword.trim() || !confirmPassword.trim()) {
      setError('กรุณากรอกรหัสผ่านใหม่ทั้งสองช่อง');
      return;
    }

    if (newPassword.length < 6) {
      setError('รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('รหัสผ่านไม่ตรงกัน');
      return;
    }

    try {
      await onSubmit({ mail: username, newPassword });
      setSuccessMsg('เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบใหม่');
      setNewPassword('');
      setConfirmPassword('');
    } catch (submitError) {
      setError(getErrorMessage(submitError, 'เปลี่ยนรหัสผ่านไม่สำเร็จ'));
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px', background: 'linear-gradient(160deg, #0d1117 0%, #111827 38%, #f7f8fa 38%, #f7f8fa 100%)' }}>
      <div className="form-card" style={{ width: '100%', maxWidth: '460px', padding: '28px 30px' }}>
        <div style={{ marginBottom: '18px' }}>
          <div className="logo-badge" style={{ color: 'var(--ink)', marginBottom: '10px' }}>
            <div className="logo-dot"></div>
            BSR · SYSREG
          </div>
          <div style={{ fontSize: '24px', fontWeight: 800, color: 'var(--ink)', lineHeight: 1.2 }}>
            รีเซ็ตรหัสผ่าน
          </div>
          <div style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '8px' }}>
            กรุณาตั้งรหัสผ่านใหม่สำหรับ <strong>{username}</strong>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '14px' }}>
            <label>รหัสผ่านใหม่</label>
            <div style={{ position: 'relative' }}>
              <input
                className="form-input"
                type={showPassword ? 'text' : 'password'}
                autoComplete="new-password"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                placeholder="อย่างน้อย 6 ตัวอักษร"
                style={{ paddingRight: '52px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px',
                  color: 'var(--text2)', padding: '4px',
                }}
              >
                {showPassword ? 'ซ่อน' : 'แสดง'}
              </button>
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: '14px' }}>
            <label>ยืนยันรหัสผ่านใหม่</label>
            <input
              className="form-input"
              type={showPassword ? 'text' : 'password'}
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              placeholder="กรอกรหัสผ่านอีกครั้ง"
            />
            {confirmPassword && !isPasswordMatch && (
              <div style={{ fontSize: '12px', color: 'var(--red)', marginTop: '4px' }}>
                รหัสผ่านไม่ตรงกัน
              </div>
            )}
          </div>

          {error && (
            <div className="alert alert-danger" style={{ marginBottom: '14px' }}>
              {error}
            </div>
          )}

          {successMsg && (
            <div className="alert alert-info" style={{ marginBottom: '14px' }}>
              {successMsg}
            </div>
          )}

          <button
            className="btn btn-primary"
            type="submit"
            disabled={loading || !isPasswordMatch}
            style={{ width: '100%', justifyContent: 'center', marginBottom: '10px' }}
          >
            {loading ? 'กำลังดำเนินการ...' : 'เปลี่ยนรหัสผ่าน'}
          </button>

          <button
            type="button"
            className="btn btn-ghost"
            onClick={onBack}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            กลับไปหน้าเข้าสู่ระบบ
          </button>
        </form>
      </div>
    </div>
  );
}
